import { render, staticRenderFns } from "./TwoCardsText.vue?vue&type=template&id=6469ccc7"
import script from "./TwoCardsText.vue?vue&type=script&lang=js"
export * from "./TwoCardsText.vue?vue&type=script&lang=js"
import style0 from "./TwoCardsText.vue?vue&type=style&index=0&id=6469ccc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports